import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gridCellFormat',
  standalone: true
})
export class GridCellFormatPipe implements PipeTransform {

  transform(value: any, field: string): string {

    var format = String(value);
    if (format === undefined || format === "" || format === "undefined") {
      format = "";
      if (field) {
        if (field.toLocaleLowerCase().includes("price") || field.toLocaleLowerCase().includes("amount") || field.toLocaleLowerCase().includes("cost")) {
          return "{0:C}";
        }
        else if (field.toLocaleLowerCase().includes("date") || field.toLocaleLowerCase().includes("timestamp") || field.toLocaleLowerCase().startsWith("when")) {
          return "{0:MM/dd/yyyy hh:mm:ss}";
        }
      }
    }

    return format;

  }

}
